/**
 * Used when sending a param to the FUIStackedPageService
 */
import {EditMode} from "./edit-mode";

export class EditParams {
    readonly identifier: any;
    readonly editMode: EditMode;
    readonly parentEntity: any;
    readonly params: any;
    readonly allowClone: boolean;

    public static isInstance(object: any): boolean {
        return object != undefined && object instanceof EditParams;
    }

    constructor(identifier: any, editMode: EditMode = EditMode.EDIT, parentEntity?: any, params?: any, allowClone: boolean = false) {
        this.identifier = identifier;
        this.editMode = editMode;
        this.parentEntity = parentEntity;
        this.params = params;
        this.allowClone = allowClone;
    }
}
